module.exports = __webpack_public_path__ + "media/images/country_flags/gd-5eb0b2b6eaa495146c2558c81781c142.png";